import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split',
})
export class SplitPipe implements PipeTransform {
  transform<T>(values: T[], each: number): T[][] {
    const splitValues = values.reduce((result, value, index, array) => {
      if (index % each === 0) {
        result.push(array.slice(index, index + each));
      }
      return result;
    }, []);
    return splitValues as T[][];
  }
}
